import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiIJsselsteinRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="IJsselstein"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={62.50}
      distance="52 km"
      duration="42-48 minuten"
    />
  );
}
